import axios from "axios";

// Backend URL resolution with a defensive fallback:
// 1. Use REACT_APP_BACKEND_URL when set (preview + properly-configured prod)
// 2. Otherwise, fall back to the current page's origin. This keeps the frontend
//    working in production even if the env var is accidentally missing or
//    points to a stale preview URL — as long as backend is served on the same
//    origin (joshifusiontech.de → frontend + /api → backend, which is the
//    standard Emergent native deployment setup).
const ENV_BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
const RUNTIME_ORIGIN =
  typeof window !== "undefined" && window.location && window.location.origin
    ? window.location.origin
    : "";

const BACKEND_URL = ENV_BACKEND_URL || RUNTIME_ORIGIN;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 60000,
  withCredentials: true,
});

export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);

export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || "1x00000000000000000000AA";

export const sendChat = (sessionId, message, locale) =>
  api.post("/chat", { session_id: sessionId, message, locale }).then((r) => r.data);

export const submitQualifiedLead = (payload) =>
  api.post("/leads/qualified", payload).then((r) => r.data);

export const trackFunnel = (payload) =>
  api.post("/chat/funnel", payload).catch(() => {});
